import React, { ReactElement } from 'react';
import { LayoutContent } from '.';
import cIf from 'classnames';

interface TicketSelectionLayoutProps {
    leftCol?: string | ReactElement | ReactElement[];
    rightCol?: string | ReactElement | ReactElement[];
    className?: string;
}

export function TicketSelectionLayout({leftCol, rightCol, className}: TicketSelectionLayoutProps): ReactElement {
    return <div className={cIf(["ticket-selection-layout", className])}>
        {leftCol && <LayoutContent className="left-content">{leftCol}</LayoutContent>}
        {rightCol && <LayoutContent className="right-content">{rightCol}</LayoutContent>}
    </div>;
}